import { ImportStatePill } from "PFApp/components/import_modal/components/parts/import_state_pill";
import { BulkOperationsState } from "PFCore/services/bulk_operations";
import { Color, ImportState } from "PFTypes";
import { useTranslation } from "react-i18next";

const STATE_COLORS: Record<ImportState | BulkOperationsState, { background: Color; text: Color }> = {
  [BulkOperationsState.Completed]: { background: "paletteGreen0", text: "paletteWhite0" },
  [BulkOperationsState.PartiallyCompleted]: { background: "paletteOrange4", text: "paletteWhite0" },
  [BulkOperationsState.Failed]: { background: "paletteRed1", text: "paletteWhite0" },
  [BulkOperationsState.Processing]: { background: "paletteNeutral0", text: "paletteBlue0" },
  created: { background: "paletteNeutral0", text: "paletteBlue0" },
  [BulkOperationsState.Queued]: { background: "paletteNeutral0", text: "paletteBlue0" }
};

type ImportStatePillProps<T extends string> = { state: T };

export const ImportHistoryStatePill = <T extends ImportState | BulkOperationsState = ImportState>({
  state
}: ImportStatePillProps<T>) => {
  const { t } = useTranslation();
  const { background, text } = STATE_COLORS[state] ?? { background: "paletteNeutral0", text: "paletteBlue0" };

  return (
    <ImportStatePill
      text={t(`importFiles.history.table.statePill.${state}` as unknown as TemplateStringsArray)}
      backgroundColor={background}
      textColor={text}
    />
  );
};
